/* eslint-disable @typescript-eslint/no-var-requires */
export const phoenixAccountGetCustomerWishlists = require('./phoenixAccountGetCustomerWishlists.graphql');
